import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private http: HttpClient, 
    private router: Router) { }

  private loginData = new BehaviorSubject<any>(this.getStoredLoginData()); // Load from localStorage

  public getSubmitLogin(body: any): Observable<any> {
    const params = new HttpParams()
      .set('email', body.email)
      .set('password', body.password)

    return this.http.get(environment.BASE_URL + '/auth/login', { params: params });
  }

  public getSubmitRegister(body: any): Observable<any> {
    const params = new HttpParams()
      .set('email', body.email)
      .set('password', body.password)
      .set('fullName', body.fullName)
      .set('birthdate', body.birthdate)
      .set('education', body.education);

    return this.http.post(environment.BASE_URL + '/auth/register', params);
  }

  public posttSendOtp(body: any): Observable<any> {
    const params = new HttpParams()
      .set('email', body.email)
      .set('purpose', body.purpose);

    return this.http.post(environment.BASE_URL + '/auth/otp', params);
  }

  public postSendOtpForgotPassword(email: string): Observable<any> {
    const params = new HttpParams()
      .set('email', email)
      .set('purpose', 'forgot');

    return this.http.post(environment.BASE_URL + '/auth/otp', params);
  }

  public getVerfiyOtp(body: any): Observable<any> {
    const params = new HttpParams()
      .set('email', body.email)
      .set('otp', body.otp)
      .set('token', body.token)
      .set('purpose', body.purpose);

    return this.http.get(environment.BASE_URL + '/auth/otp/verify', { params: params });
  }

  public getVerifyOtpForgotPassword(body: any): Observable<any> {
    const params = new HttpParams()
      .set('email', body.email)
      .set('otp', body.otp)
      .set('token', body.token)
      .set('purpose', 'forgot');

    return this.http.get(environment.BASE_URL + '/auth/otp/verify', { params: params });
  }

  public saveLocalStorageLogin(userData: any) {
    localStorage.setItem('login', JSON.stringify(userData));
  }

  public loadLocalStorage(item: string) {
    const data = localStorage.getItem(item)
    return JSON.parse(data ? data : '');
  }

  // Store login response in BehaviorSubject and localStorage
  setLoginData(data: any) {
    localStorage.setItem('loginData', JSON.stringify(data)); // Store in localStorage
    this.loginData.next(data);
  }

  // Retrieve login data from BehaviorSubject
  getLoginData(): Observable<any> {
    return this.loginData.asObservable();
  }

  // Retrieve login data from localStorage (if available)
  public getStoredLoginData() {
    const storedData = localStorage.getItem('loginData');
    return storedData ? JSON.parse(storedData) : null;
  }

  // Refresh token
  public refreshToken(): Observable<any> {
    const loginData = this.getStoredLoginData();
    const refreshToken = loginData?.refreshToken;

    const params = new HttpParams().set('refreshToken', refreshToken || '');
    return this.http.get(environment.BASE_URL + '/auth/refresh-token', { params });
  }

  // Update token after refresh
  public updateToken(newToken: string, newRefreshToken: string) {
    const storedData = this.getStoredLoginData();
    if (storedData) {
      storedData.token = newToken;
      storedData.refreshToken = newRefreshToken;
      localStorage.setItem('loginData', JSON.stringify(storedData));
      this.loginData.next(storedData);
    }
  }

  public patchChangePassword(email: string, password: string, token: string): Observable<any> {
    const params = new HttpParams()
      .set('email', email)
      .set('password', password)
      .set('token', token);

    return this.http.patch(environment.BASE_URL + '/auth/change-password', null, {
      params: params,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
  }

  // Clear data on logout
  clearLoginData() {
    localStorage.removeItem('loginData');
    this.loginData.next(null);
  }

  public logOut() {
    localStorage.clear();
    this.router.navigate(['/']);
  }
}
